import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { getQueryParameter } from '@iwRouter/LocationHelper';

export function useFundingRequirementsParams() {
    const location = getCurrentLocation();
    const offerId = getQueryParameter(location, 'offerId');
    const amount = getQueryParameter(location, 'amount');

    if (!offerId) {
        const message =
            'useFundingRequirementsParams: missing offerId in URL parameters';
        logError(message, { tags: TAGS.DE_LENDING });
        throw new Error(message);
    }

    if (amount === undefined) {
        const message =
            'useFundingRequirementsParams: missing amount in URL parameters';
        logError(message, { tags: TAGS.DE_LENDING });
        throw new Error(message);
    }

    return {
        offerId,
        drawdownAmount: Number(amount)
    };
}
